export default __webpack_public_path__ + "static/media/interior.8dbb574c.png";